export const TABLE_DATA = {
  heading: "Comparison of Emulation, Simulation, and Real-World Testing",
  columns: ["Emulation ", "Simulation ", "Real-World Testing"],
  data: [
    {
      feature: "Purpose",
      "Emulation ": "Replicates system behavior with software",
      "Simulation ": "Models system behavior based on defined parameters",
      "Real-World Testing": "Tests technology in a live operational environment",
    },
    {
      feature: "Accuracy",
      "Emulation ": "High-fidelity reproduction of actual devices",
      "Simulation ": "Predictive modeling based on theoretical data",
      "Real-World Testing": "100% real-world validation",
    },
    {
      feature: "Use Cases",
      "Emulation ": "Network and hardware testing, virtualization",
      "Simulation ": "Performance tuning, design validation",
      "Real-World Testing": "Production deployment, operational benchmarking",
    },
    {
      feature: "Hardware Dependence",
      "Emulation ": "No physical hardware required",
      "Simulation ": "Can be hardware-dependent",
      "Real-World Testing": "Requires actual infrastructure",
    },
    {
      feature: "Scalability",
      "Emulation ": "Easily scalable in virtual environments",
      "Simulation ": "Scalable based on computing resources",
      "Real-World Testing": "Limited by physical infrastructure",
    },
    {
      feature: "Cost",
      "Emulation ": "Cost-effective; no hardware needed",
      "Simulation ": "Moderate cost depending on computational needs",
      "Real-World Testing": "Higher cost due to real infrastructure and operations",
    },
  ],
};
